<template>
    <div class="fullPage">
        <!--选择题-->
        <div class="chapter"
             v-if="testList.length">
            <img src="../../assets/img/team/fu_tit02.png"
                 class="fuTit">
            <div class="main">
                <div class="know">历年期末考试真题资料</div>
                <div class="weak">完成在线练习后，有机会获得红包</div>
                <div class="select"
                     @click="show = true">{{ test }}<img src="../../assets/img/team/blue_jiantou.png"
                         class="arrow"></div>
                <p class="examTit">选择题专练</p>
                <ul class="choice">
                    <li class="everyTest"
                        v-for="(item,index) in testList"
                        @click="doExamSin(index)">
                        <div class="testPaper">
                            <span class="selCon">{{ item }}</span>
                            <span class="midTit">共{{ countList[index] }}题，难度{{ diffList[index] }}</span>
                        </div>
                        <span class="learn testLearn"
                              v-if="doneList[index] === '去练习'">{{ doneList[index] }}<img src="../../assets/img/team/blue_jiantou.png" class="arrow"></span>
                        <span class="learn testLearn learned"
                              v-if="doneList[index] === '已练习'">{{ doneList[index] }}<img src="../../assets/img/team/gray.png" class="arrow"></span>
                    </li>
                </ul>
            </div>
            <img src="../../assets/img/team/fu_tit03.png"
                 class="fuTit">
        </div>
        <!--填空题-->
        <div class="chapterBank"
             v-if="bankList.length">
            <img src="../../assets/img/team/line.png"
                 class="fuTit bankTit">
            <div class="main">
                <p class="examTit examBank">填空题资料</p>
                <ul class="choice">
                    <li class="everyTest"
                        v-for="(item,index) in bankList"
                        @click="doExamBank(index)">
                        <div class="testPaper bankPaper">
                            <span class="selCon">{{ item }}</span>
                        </div>
                        <span class="learn testLearn">查看<img src="../../assets/img/team/blue_jiantou.png" class="arrow"></span>
                    </li>
                </ul>
            </div>
            <img src="../../assets/img/team/fu_tit03.png"
                 class="fuTit">
        </div>
        <!--解答题-->
        <div class="chapterBank chapterAnswer"
             v-if="answerList.length">
            <img src="../../assets/img/team/line.png"
                 class="fuTit bankTit">
            <div class="main">
                <p class="examTit examBank">解答题资料</p>
                <ul class="choice">
                    <li class="everyTest"
                        v-for="(item,index) in answerList"
                        @click="doExamAnswer(index)">
                        <div class="testPaper bankPaper">
                            <span class="selCon">{{ item }}</span>
                        </div>
                        <span class="learn testLearn">查看<img src="../../assets/img/team/blue_jiantou.png" class="arrow"></span>
                    </li>
                </ul>
            </div>
            <img src="../../assets/img/team/fu_tit03.png"
                 class="fuTit">
        </div>
        <Picker :data='selDatas'
                :show="show"
                @close="show = !show"
                @change="changeHandler"></Picker>
    </div>
</template>
    
<script>
import Picker from '@/components/picker/index'
export default {
    components: { Picker },
    data: function () {
        return {
            test: '',
            testList: [],
            bankList: [],
            answerList: [],
            countList: [],
            diffList: [],
            doneList: [],
            show: false,
            selDatas: [
                {
                    title: '选择教材',
                    list: [
                        {
                            key: 15,
                            value: '苏科版'
                        },
                        {
                            key: 30,
                            value: '人教新版'
                        },
                        {
                            key: 23,
                            value: '华师大版'
                        },
                        {
                            key: 31,
                            value: '北师新版'
                        }
                    ],
                    currentIndex: 0
                },
                {
                    title: '',
                    list: [
                        {
                            key: 1,
                            value: '初一'
                        },
                        {
                            key: 2,
                            value: '初二'
                        },
                        {
                            key: 3,
                            value: '初三'
                        }
                    ],
                    currentIndex: 0
                }
            ]
        }
    },
    beforeRouteLeave (to, from, next) {
        window.scrollTo(0, 0)
        next()
    },
    mounted: function () {
        // 查询用户版本年级信息
        this.$http.post('/zy/m/s/examActivity01/getUser', {}, {
            params: {
                code: this.$route.params.code
            }
        }).then((response) => {
            if (response.data.ret.user) {
                this.userInfo = response.data.ret.user
                switch (this.userInfo.textbookCategoryCode) {
                    case 15:
                        this.test = '苏科版'
                        this.selDatas[0].currentIndex = 0
                        break
                    case 30:
                        this.test = '人教新版'
                        this.selDatas[0].currentIndex = 1
                        break
                    case 23:
                        this.test = '华师大版'
                        this.selDatas[0].currentIndex = 2
                        break
                    case 31:
                        this.test = '北师新版'
                        this.selDatas[0].currentIndex = 3
                        break
                }
                switch (this.userInfo.grade) {
                    case 1:
                        this.test += ' 初一'
                        this.selDatas[1].currentIndex = 0
                        break
                    case 2:
                        this.test += ' 初二'
                        this.selDatas[1].currentIndex = 1
                        break
                    case 3:
                        this.test += ' 初三'
                        this.selDatas[1].currentIndex = 2
                        break
                }
                // 查询试卷
                this.$http.post('/zy/m/s/examActivity01/getPastExams', {}, {
                    params: {
                        code: this.$route.params.code,
                        category: this.userInfo.textbookCategoryCode,
                        grade: this.userInfo.grade
                    }
                }).then((response) => {
                    this.allExam = response.data.ret
                    for (let i = 0; i < this.allExam.exams1.length; i++) {
                        if (this.allExam.exams1[i]) {
                            this.testList.push(this.allExam.exams1[i].name)
                            this.countList.push(this.allExam.exams1[i].questionCount)
                            if (this.allExam.exams1[i].difficulty >= 0 && this.allExam.exams1[i].difficulty < 0.4) {
                                this.diffList.push('困难')
                            } else if (this.allExam.exams1[i].difficulty >= 0.4 && this.allExam.exams1[i].difficulty < 0.8) {
                                this.diffList.push('中等')
                            } else if (this.allExam.exams1[i].difficulty >= 0.8 && this.allExam.exams1[i].difficulty <= 1) {
                                this.diffList.push('简单')
                            }
                            if (this.allExam.exams1[i].done) {
                                this.doneList.push('已练习')
                            } else {
                                this.doneList.push('去练习')
                            }
                        }
                    }
                    // 填空题
                    if (this.allExam.exams3) {
                        for (let i = 0; i < this.allExam.exams3.length; i++) {
                            this.bankList.push(this.allExam.exams3[i].name)
                        }
                    }
                    // 解答题
                    if (this.allExam.exams5) {
                        for (let i = 0; i < this.allExam.exams5.length; i++) {
                            this.answerList.push(this.allExam.exams5[i].name)
                        }
                    }
                }, (response) => {
                    // to do
                })
            }
        }, (response) => {
            // to do
        })
        // 13265656
        // this.$http.post('/zy/m/s/examActivity01/getPastExams', {}, {}).then((response) => {
        //     console.log(response.data)
        //     this.allExam = response.data.ret
        //     switch (this.allExam.category) {
        //         case 15:
        //             this.test = '苏科版'
        //             this.selDatas[0].currentIndex = 0
        //             break
        //         case 30:
        //             this.test = '人教新版'
        //             this.selDatas[0].currentIndex = 1
        //             break
        //         case 23:
        //             this.test = '华师大版'
        //             this.selDatas[0].currentIndex = 2
        //             break
        //         case 31:
        //             this.test = '北师新版'
        //             this.selDatas[0].currentIndex = 3
        //             break
        //     }
        //     switch (this.allExam.grade) {
        //         case 1:
        //             this.test += ' 初一'
        //             this.selDatas[1].currentIndex = 0
        //             break
        //         case 2:
        //             this.test += ' 初二'
        //             this.selDatas[1].currentIndex = 1
        //             break
        //         case 3:
        //             this.test += ' 初三'
        //             this.selDatas[1].currentIndex = 2
        //             break
        //     }
        //     // 选择题
        //     for (let i = 0; i < this.allExam.exams1.length; i++) {
        //         this.testList.push(this.allExam.exams1[i].name)
        //         this.countList.push(this.allExam.exams1[i].questionCount)
        //         if (this.allExam.exams1[i].difficulty >= 0 && this.allExam.exams1[i].difficulty < 0.4) {
        //             this.diffList.push('困难')
        //         } else if (this.allExam.exams1[i].difficulty >= 0.4 && this.allExam.exams1[i].difficulty < 0.8) {
        //             this.diffList.push('中等')
        //         } else if (this.allExam.exams1[i].difficulty >= 0.8 && this.allExam.exams1[i].difficulty <= 1) {
        //             this.diffList.push('简单')
        //         }
        //         if (this.allExam.exams1[i].done) {
        //             this.doneList.push('已练习')
        //         } else {
        //             this.doneList.push('去练习')
        //         }
        //     }
        //     // 填空题
        //     for (let i = 0; i < this.allExam.exams3.length; i++) {
        //         this.bankList.push(this.allExam.exams3[i].name)
        //     }
        //     // 解答题
        //     for (let i = 0; i < this.allExam.exams5.length; i++) {
        //         this.answerList.push(this.allExam.exams5[i].name)
        //     }
        // }, (response) => {
        //     // to do
        // })
    },
    methods: {
        changeHandler: function (msg) {
            this.test = msg[0].value + ' ' + msg[1].value
            console.log(msg[0].key)
            switch (msg[0].key) {
                case 15:
                    this.selDatas[0].currentIndex = 0
                    break
                case 30:
                    this.selDatas[0].currentIndex = 1
                    break
                case 23:
                    this.selDatas[0].currentIndex = 2
                    break
                case 31:
                    this.selDatas[0].currentIndex = 3
                    break
            }
            switch (msg[1].key) {
                case 1:
                    this.selDatas[1].currentIndex = 0
                    break
                case 2:
                    this.selDatas[1].currentIndex = 1
                    break
                case 3:
                    this.selDatas[1].currentIndex = 2
                    break
            }
            // 为用户添加教材版本信息
            this.$http.post('/zy/m/s/examActivity01/addUserCategory', {}, {
                params: {
                    code: this.$route.params.code,
                    category: msg[0].key,
                    grade: msg[1].key
                }
            }).then((response) => {
                console.log(response.data)
            }, (response) => {
                // to do
            })
            // 清空数据
            this.testList = []
            this.bankList = []
            this.answerList = []
            this.countList = []
            this.diffList = []
            this.doneList = []
            this.$http.post('/zy/m/s/examActivity01/getPastExams', {}, {
                params: {
                    code: this.$route.params.code,
                    category: msg[0].key,
                    grade: msg[1].key
                }
            }).then((response) => {
                this.allExam = response.data.ret
                // 选择题
                for (let i = 0; i < this.allExam.exams1.length; i++) {
                    this.testList.push(this.allExam.exams1[i].name)
                    this.countList.push(this.allExam.exams1[i].questionCount)
                    if (this.allExam.exams1[i].difficulty >= 0 && this.allExam.exams1[i].difficulty < 0.4) {
                        this.diffList.push('困难')
                    } else if (this.allExam.exams1[i].difficulty >= 0.4 && this.allExam.exams1[i].difficulty < 0.8) {
                        this.diffList.push('中等')
                    } else if (this.allExam.exams1[i].difficulty >= 0.8 && this.allExam.exams1[i].difficulty <= 1) {
                        this.diffList.push('简单')
                    }
                    if (this.allExam.exams1[i].done) {
                        this.doneList.push('已练习')
                    } else {
                        this.doneList.push('去练习')
                    }
                }
                // 填空题
                for (let i = 0; i < this.allExam.exams3.length; i++) {
                    this.bankList.push(this.allExam.exams3[i].name)
                }
                // 解答题
                for (let i = 0; i < this.allExam.exams5.length; i++) {
                    this.answerList.push(this.allExam.exams5[i].name)
                }
            }, (response) => {
                // to do
            })
        },
        doExamSin: function (index) {
            console.log(this.allExam.exams1[index].name)
            this.$client.system('doExamPractice', {
                'activityCode': this.$route.params.code,
                'examCode': this.allExam.exams1[index].code,
                'examName': this.allExam.exams1[index].name,
                'qtype': this.allExam.exams1[index].type
            })
        },
        doExamBank: function (index) {
            console.log(this.allExam.exams3[index].name)
            this.$client.system('doExamPractice', {
                'activityCode': this.$route.params.code,
                'examCode': this.allExam.exams3[index].code,
                'examName': this.allExam.exams3[index].name,
                'qtype': this.allExam.exams3[index].type
            })
        },
        doExamAnswer: function (index) {
            console.log(this.allExam.exams5[index].name)
            this.$client.system('doExamPractice', {
                'activityCode': this.$route.params.code,
                'examCode': this.allExam.exams5[index].code,
                'examName': this.allExam.exams5[index].name,
                'qtype': this.allExam.exams5[index].type
            })
        }
    }
}
</script>
    
<style scoped>
.fullPage {
    position: absolute;
    width: 100%;
    min-height: 100%;
    background-color: #2ab7f7;
    top: 0px;
    left: 0px;
}

.chapter {
    margin-top: 90px;
}

.chapterBank {
    margin-top: 30px;
}

.fuTit {
    width: 750px;
    height: 100px;
    display: block;
    margin-bottom: -2px;
    margin-top: -2px;
}

.main {
    width: 750px;
    background-image: url('../../assets/img/team/fu_tit04.png');
    background-size: 750px;
}

.know {
    font-size: 35px;
    font-weight: 600;
    text-align: center;
}

.weak {
    font-size: 25px;
    font-weight: 600;
    color: #839096;
    margin-top: 20px;
    text-align: center;
}

.select {
    color: #007aff;
    font-size: 28px;
    font-weight: 600;
    margin-top: 30px;
    text-align: center;
    margin-bottom: 15px;
}

.arrow {
    width: 16px;
    height: 25px;
    margin-left: 10px;
}

.everyTest {
    width: 622px;
    height: 100px;
    border: 4px solid #000000;
    border-radius: 15px;
    margin: 0 auto;
    font-size: 30px;
    background-color: #e1feff;
    margin-top: 20px;
    color: #000;
}

.testPaper {
    width: 400px;
    padding-top: 20px;
    padding-left: 26px;
    display: inline-block;
}

.bankPaper {
    padding-top: 35px;
}

.selCon {
    font-weight: 600;
    width: 400px;
    display: inline-block;
    padding-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.midTit {
    font-size: 23px;
    color: #326264;
}

.learn {
    color: #007aff;
    font-size: 30px;
    font-weight: 600;
    margin-right: 26px;
    float: right;
}

.testLearn {
    padding-top: 35px;
}

.examTit {
    color: #000;
    font-weight: 600;
    text-align: center;
    font-size: 30px;
    margin-top: 45px;
    margin-bottom: 30px;
}

.examBank {
    margin-top: 0px;
}

.bankTit {
    height: 45px;
}

.chapterAnswer {
    margin-bottom: 40px;
}

.learned {
    color: #839096;
}
.choice {
    padding-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// exam.vue?edcde2c0